module.exports = __webpack_public_path__ + "img/polyvagaal_autonome_zenuw_stelsel.bf51eaba.png";